import {InventoryTheme} from './Theme.js';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import {DefaultSearchHandler} from './SearchHandler.js';
import {DefaultSearchFields} from './SearchFields.js';

const defaultSettings = {
    inventoryTypes: {
        NONE: 0,
        TRAILER: 1,
        TRUCK: 2,
        DEALER: 3,
        GENERAL: 4,
        PART: 5,
        OLDTRACTOR: 6,
        INVENTORY: 7,
        BARRELDRAW: 8,
        TACK: 9,
        CARGO: 10,
        REVIEW: 11,
        HORSE: 12,
        WORKINGHORSE: 13,
        HAY: 14,
        EVENTS: 15,
        HORSEPROPERTY: 16
    },
    inventoryFieldType : {
        MULTIPLE : 1,
        RADIO : 2,
        TEXTBOX : 3,
        TEXTAREA : 4,
        NUMBER : 5,
        DATE : 6,
        YESNO : 7,
        RADIOWITHTEXT : 8,
        MULTIPLEWITHTEXT : 9,
        YEAR : 10,
        SELECT : 11,
        SELECTWITHTEXT : 12,
        AUTOCOMPLETE : 13,
        STATE : 14
    },
    inventoryQueryType : {
        TITLE : 1,
        DESCRIPTION: 2,
        CONTACTCITY : 3,
        CONTACTSTATE : 4,
        CONTACTZIP : 5,
        CONTACTEMAIL : 6,
        PRICE : 7,
        ISSOLD : 8,
        ISREDUCED : 9,
        QUESTION : 10
    },
    pageSize: 25,
    trailersUrl : "https://horsetrailerworld.com/remote/publicXML/TrailerList.aspx",
    cargoUrl : "https://horsetrailerworld.com/remote/publicXML/CargoList.aspx",
    trucksUrl: "https://horsetrailerworld.com/remote/publicXML/TruckList.aspx",
    partsUrl: "https://horsetrailerworld.com/remote/publicXML/PartList.aspx",

    showPrintButton: true,
    printButtonText: "🖨",
    showResetButton: false,

    // New inventory system
    baseApi: "https://api.equinemediaworld.com/api/v1/",
    authHeader: "Basic ciUlbSZxYCUoSkApfnhV",
    showEditButton: false,
    memberId: 0,

    showTrailers: true,
    showCargo: true,
    showTrucks: true,
    showParts: true,
    showInventory: true,

    hideTrailerSearchFieldsByLabel: [],
    hideCargoSearchFieldsByLabel: [],
    hideTruckSearchFieldsByLabel: [],
    hidePartSearchFieldsByLabel: [],

    socialShareUseCanonicalUrls: true
};
let Settings = {...defaultSettings, ...window.__inventoryDefaults};
export { Settings, DefaultSearchFields, InventoryTheme, DefaultSearchHandler }